<div class="content-selection col-sm-12 col-md-8">
    <label class="content-selection__label">
        <span>{{ block.data.heading }}</span>
        <select class="form-select content-selection__select" (change)="onSelectionChange($event)">
            @for (item of block.content; track item.id; let i = $index) {
                <option [value]="i" [innerHTML]="item.data.title"></option>
            }
        </select>
    </label>

    @if (block.data.description) {
        <div class="content-selection__description" [innerHTML]="block.data.description"></div>
    }

    <div class="content-selection__display" aria-live="polite">
        @for (item of block.content; track item.id; let i = $index) {
            @if (selectedItemIndex() === i) {
                <div class="content-selection__item {{ block.data.title }} {{ block.data.visibility }}">
                    @for (subBlock of item.content; track subBlock.id) {
                        <core-block [block]="subBlock"></core-block>
                    }
                </div>
            }
        }
    </div>
</div>
